"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BATCH_REQ_TIMEOUT_DEFAULT = exports.REQUEST_TIMEOUT_DEFAULT = exports.BATCH_MAX_SIZE = exports.CACHE_VSN = exports.HOST = void 0;
exports.HOST = "ipinfo.io";
exports.CACHE_VSN = "1";
exports.BATCH_MAX_SIZE = 1000;
exports.REQUEST_TIMEOUT_DEFAULT = 5000;
exports.BATCH_REQ_TIMEOUT_DEFAULT = 5000;
